import React, {Component} from 'react';
import {Grid, Row, Col, FormGroup, ControlLabel, Form, FormControl} from "react-bootstrap";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import moment from "moment";
import DataAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";


export default class FakturyBiletySearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: '',
            dataDo: '',
            nipLubPesel:'',
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeNIPlubPESEL = this.onChangeNIPlubPESEL.bind(this)
    }

    componentDidMount() {
      /*  let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month()) + 1;

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')

        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())

        this.setState({
            dataOd: (pierwszy_miesiaca),
            dataDo: (ostatni_miesiaca),
        })*/
        this.setState({
            dataOd: (moment()),
            dataDo: (moment()),
        })
    }

    componentWillReceiveProps(nextprops){
    }

    onChangeDataOd(e) {
        this.setState({dataOd:e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo:e})
    }

    onChangeNIPlubPESEL(e) {
        if(e.target.value.length <= 30){
            this.setState({nipLubPesel: e.target.value})
        }
        else{
            document.getElementById('inputNipLubPesel').value = this.state.nipLubPesel
            this.setState({nipLubPesel: this.state.nipLubPesel})
        }
    }

    onClickSzukaj(){
        if(DataAndTimeFormat.formatYYYYMMDD(this.state.dataDo) >= DataAndTimeFormat.formatYYYYMMDD(this.state.dataOd)){
            this.props.handleClickSearch({
                dataOd:DataAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                dataDo:DataAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                nipLubPesel:this.state.nipLubPesel
            })
        }else{
            alert('Podano nieprawidłowy zakres dat!')
        }
    }

    render() {

        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup style={{marginBottom: '0'}}>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Data wystawienia od <span style={{color: 'red'}}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Data wystawienia do <span style={{color: 'red'}}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={12} lg={2}>
                            <ControlLabel>NIP lub PESEL</ControlLabel> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nipLubPesel.length}/30 znaków</span>
                            <FormControl type={'text'} onChange={this.onChangeNIPlubPESEL} id={'inputNipLubPesel'}/>
                        </Col>
                        <Col xs={12} lg={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction text={'Szukaj'} iconType={'fa fa-search'} btnSize={'md'} btnColor={'primary'} onClick={()=>this.onClickSzukaj()}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/fakturyBilety/components/FakturyBiletySearchbox.js